
import TPEAction from 'src/models/common/TPEAction';
import { DashboardState } from 'src/models/dashboard/DashboardState'

/**
 * List here the actions supported by this reducer
 */
export const ACTIONS = Object.freeze({
  SET_OPEN_CALC_REVIEWS_PAYLOAD: new TPEAction('SET_OPEN_CALC_REVIEWS_PAYLOAD'),
  SET_OPEN_APPROVALS_PAYLOAD: new TPEAction('SET_OPEN_APPROVALS_PAYLOAD'),
  SET_OPEN_REQUESTS_PAYLOAD: new TPEAction('SET_OPEN_REQUESTS_PAYLOAD'),
  SET_OPEN_TASKS_PAYLOAD: new TPEAction('SET_OPEN_TASKS_PAYLOAD'),
  SET_SELECTED_NOTIFICATIONS: new TPEAction('SET_SELECTED_NOTIFICATIONS')
});


/**
 * This function is responsible for updating the state based on action type
 * @param state The current dashboard state
 * @param action The current dispatched action
 */
export function dashboardReducer(state: DashboardState, action: TPEAction) {
  switch (action.type) {
    case ACTIONS.SET_OPEN_CALC_REVIEWS_PAYLOAD.type: {
      return {
        ...state,
        searchOpenCalcReviewsPayload: action.payload
      }
    }
    case ACTIONS.SET_OPEN_APPROVALS_PAYLOAD.type: {
      return {
        ...state,
        searchOpenApprovalsPayload: action.payload
      }
    }
    case ACTIONS.SET_OPEN_REQUESTS_PAYLOAD.type: {
      return {
        ...state,
        searchOpenRequestsPayload: action.payload
      }
    }
    case ACTIONS.SET_OPEN_TASKS_PAYLOAD.type: {
      return {
        ...state,
        searchOpenTasksPayload: action.payload
      }
    }
    case ACTIONS.SET_SELECTED_NOTIFICATIONS.type: {
      return {
        ...state,
        selectedNotifications: action.payload
      }
    }
    default:
      return state;
  }
}